import React from 'react';
import { CONSTANTS } from '@tpco/tpco-saturn-types';
import ThomasAdvertiserCampaignsContainer from 'containers/ThomasAdvertiserCampaignsContainer';
import { Link } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { ApolloConsumer } from 'react-apollo';
import ThomasAdvertiserView from 'views/components/ThomasAdvertisers/ThomasAdvertiserView';
import { getProductNameById } from 'util/nameHelper';
import { parseUrlSearch } from 'util/queryParameters';
import { ThomasAlert } from 'views/components/Access/ThomasMessage';

interface ThomasAdvertiserPageProps {
  match: any;
  location: any;
  history: any;
}

const ThomasAdvertiserPage: React.FC<any> = ({
  match,
  location,
  history
}: ThomasAdvertiserPageProps) => {
  let { tgramsId, productId } = match.params;
  const productName = getProductNameById(Number(productId));
  const params = parseUrlSearch(location.search);
  productId = productId ? productId : '';
  console.log('productId', productId);

  return (
    <ThomasAdvertiserCampaignsContainer tgrams_id={tgramsId} product_id={productId}>
      {({
        advertiser,
        thomasCampaigns,
        templates,
        productFulfillmentsVersions,
        productFulfillments,
        userInfo,
        client
      }) => {
        if (advertiser == null) {
          return (
            <section className="card">
              <ThomasAlert />
              <br />
              <Alert variant="danger">
                This advertiser doesn't exit
                <br />
                <Link to="/">Back Home</Link>
              </Alert>
            </section>
          );
        } else {
          let data: any = [];
          switch (Number(productId)) {
            case CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS:
              data = thomasCampaigns.filter(tc => tc.product_id == productId) || [];
              break;
            case CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS:
              data = thomasCampaigns.filter(tc => tc.product_id == productId) || [];
              break;
            default:
              data = thomasCampaigns || [];
              break;
          }
          return (
            <ThomasAdvertiserView
              tgramsId={tgramsId}
              name={advertiser.name || ''}
              campaigns={data}
              templates={templates || []}
              productFulfillmentsVersions={productFulfillmentsVersions || []}
              productFulfillments={productFulfillments || []}
              userInfo={userInfo}
              client={client}
              productName={productName}
              productId={productId}
              params={params}
              history={history}
            />
          );
        }
      }}
    </ThomasAdvertiserCampaignsContainer>
  );
};

export default ThomasAdvertiserPage;
